import axios from 'axios';

import { connection } from 'config';

export const axiosInstance = axios.create({
  baseURL: connection.baseURL,
});
